require('../../modules/es6.array.of');
module.exports = require('../../modules/_core').Array.of;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/array/of.js
// module id = 287
// module chunks = 9